// How an area's priced hours are named on the desk (approved-hours.ts in m2q-pricing).
import type { ApprovedHours, SectionInfo } from '@higgins/m2q-pricing';
import { formatHours } from './surface-format';

/** "Assessed (PM)": the review's choices as the desk names them. */
export const sourceLabel = (source: ApprovedHours['source']): string => (source === 'Assessed' ? 'Assessed (PM)' : source);

/** The Take Off's "Hours priced:" for an area. */
export function hoursPricedText(info: SectionInfo): string {
  if (info.washOnly) return 'the wash m² (wash only)';
  if (!info.hours) return info.approved ? 'approved' : 'measured';
  const { source, hours, needsChoice, changed, stale } = info.hours;
  const note = stale ? ' · choose Assessed again on REVIEW' : needsChoice ? ' · PM hours to choose on REVIEW' : changed ? ' · PM hours changed, see REVIEW' : '';
  return `${sourceLabel(source)} ${formatHours(hours)}${note}`;
}
